import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  getAllInvoices (params) {
    return custAxios().get(Const.API_INVOICE, {
      params
    })
  },
  addInvoice (invoice) {
    return custAxios().post(Const.API_INVOICE, invoice)
  },
  editInvoice (invoice) {
    const { idInvoice } = invoice

    return custAxios().put(`${Const.API_INVOICE}/${idInvoice}`, invoice)
  },
  removeInvoice (invoice) {
    const { idInvoice } = invoice

    return custAxios().delete(`${Const.API_INVOICE}/${idInvoice}`)
  }
}
